module.exports = __webpack_public_path__ + "img/logo.f5c010b2.svg";